import { AdminShell } from "@project/admin/components/admin-shell";
import { FamilyDetails } from "@project/admin/components/family-details";

export default function Page() {
  return (
    <AdminShell
      title="Family Details"
      subtitle="Family member table for admission and resident records"
    >
      <FamilyDetails
        title="Family Member Table"
        subtitle="Display multiple family members"
        initialRows={5}
      />
    </AdminShell>
  );
}
